import { getBreakpoint } from '../utils/breakpoint-util';

class Doormat {
	constructor($el) {
		this.$el = $el
		this.$open = false
		this.$headers = this.$el.querySelectorAll(
			":scope > .c-doormat-footer__header"
		)
	}

	init() {
		this.addEventListeners()
	}

	openItem() {
    this.open = true
    this.$el.classList.add("c-doormat-footer__item--open")
  }

	closeItem() {
    this.open = false
		this.$el.classList.remove("c-doormat-footer__item--open")
  }

	addEventListeners() {
    if (this.$headers.length > 0) {
      this.$headers.forEach(($header) => {
        $header.addEventListener("click", () => {
          if (getBreakpoint() == "mobile") {
            if (this.open) {
              this.closeItem()
            } else {
              this.openItem()
            }
          }
        })
			})
    }
	}
}

[...document.querySelectorAll(".js--doormat")].forEach(($el) => {
	const inst = new Doormat($el)
	inst.init($el)
})